import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { RouteNavigation } from "../../../Routes";
import { GetAllSevice } from "../../../lib/api";
import {
  ShowLoadingAnimation,
  ShowNoDataAnimation,
} from "../../../components/common/Animation";
import { FaRegEdit } from "react-icons/fa";

const ServiceList = () => {
  const { isLoading, isPending, isError, data } = useQuery({
    queryKey: ["GetAllSevice"],
    queryFn: () => GetAllSevice(),
  });


 
  
  const navigate = useNavigate();
  const isUserData = data?.data?.users;
        
  return (
    <div className="py-5">
      <h4 className="text-3xl font-bold mb-5">Service</h4>
      <div className="flex justify-end">
        <Link to={RouteNavigation.create_service}>
          <button className="bg-gray-800 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
            Create New
          </button>
        </Link>
      </div>
      {isLoading || isPending ? (
        <div className="w-44 flex justify-center m-auto">
          <ShowLoadingAnimation />
        </div>
      ) : (
        <div className="w-full">
          <div className="mt-5 border-2 rounded-lg">
            <div className="overflow-auto">
              <TableContainer>
                <Table>
                  <TableHead className="bg-gray-800 rounded-xl">
                    <TableRow>
                      <TableCell style={{ color: "white" }}>Sl.No</TableCell>
                      <TableCell style={{ color: "white" }}>
                        Service Name
                      </TableCell>
                      <TableCell style={{ color: "white" }}>Department Name</TableCell>                    
                      <TableCell
                        style={{ color: "white", textAlign: "center" }}
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {!isPending && !isLoading && !isError && (
                    <TableBody>
                      {data?.data?.services?.map((service, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{service.SerName}</TableCell>
                          <TableCell>{service.DepName}</TableCell> 
                          <TableCell
                            onClick={() =>
                              navigate("/create-service", {
                                state: { serviceData: service},
                              })
                            }
                          >
                            <div className="flex justify-center">
                              <FaRegEdit
                                className="cursor-pointer"
                                size={"20px"}
                                color={service.SerStatus === true ? "green" : "red"}
                              />
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center">
        {isError && !isUserData && (
          <div className="w-44 flex justify-center">
            <ShowNoDataAnimation />
          </div>
        )}
      </div>
    </div>
  );
};
export default ServiceList;
